export default __webpack_public_path__ + "static/media/jangwon_profile.4640a756.jpeg";